import { redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { ALL_AREAS, baseOf, type AreaBase } from './navigation';
import { TableSearch } from './table-search';

/**
 * What the routes of the firm's areas and settings decide before a page loads - kept apart from
 * the pages (`area-view.tsx`), which the router loads only when one is opened.
 */

/**
 * An area asked for under the other place - an old link to `/settings/team` - leads to where
 * it lives now, with what the address held.
 */
function leadToPlace(base: AreaBase, area: string, search: TableSearch) {
  const home = baseOf(area);
  if (home === base || !ALL_AREAS.some((entry) => entry.area.slug === area)) return;
  redirect({ to: `${home}/$area`, params: { area }, search, replace: true, throw: true });
}

/** The route of the areas of a place (`/firm/$area`, `/settings/$area`), without its page. */
export const areaRoute = (base: AreaBase) => ({
  // An area with a table keeps its view in the address.
  validateSearch: TableSearch,
  beforeLoad: ({ params, search }: { params: { area: string }; search: TableSearch }) =>
    leadToPlace(base, params.area, search),
});

/** `?view=list`: the areas as a list by topic; without it, as tiles. */
export const OVERVIEW_ROUTE = {
  validateSearch: z.object({ view: z.literal('list').optional().catch(undefined) }),
};
